export const handleScrollToTop = async (callbackFunction?: () => void): Promise<void> => {
  if (window !== undefined) {
    const scrollToTopAndThen = (callback?: () => void) => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
      // Use requestAnimationFrame to check if the page has finished scrolling
      const checkScroll = () => {
        // If the scroll position is at the top, execute the next callback
        if (window.scrollY === 0) {
          // Stop the requestAnimationFrame loop and perform the next callback
          callback?.()
        } else {
          // Otherwise, keep checking
          requestAnimationFrame(checkScroll)
        }
      }
      // Start checking if the scroll is complete
      requestAnimationFrame(checkScroll)
    }

    scrollToTopAndThen(callbackFunction)
  }
}
